import { useEffect, useState } from "react";

// Scale for the figure in focus view: fill the screen height without overflowing the width.
export function useFocusStyle(focus) {
  const [s, setS] = useState(1);
  useEffect(() => {
    if (!focus) {
      setS(1);
      return;
    }
    const fit = () => {
      const W = window.innerWidth;
      const H = window.innerHeight;
      const bw = Math.min(0.72 * W, 380);
      const bh = (bw * 1264) / 848;
      // fit the fully bloomed Flower of Life (≈107% of the figure's height, ≈158% of its width, incl. glow);
      // never shrink below the normal view
      setS(Math.max(1, Math.min((H * 0.96) / (bh * 1.07), (W * 0.98) / (bw * 1.58))));
    };
    fit();
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, [focus]);
  return { transform: `scale(${s})`, transition: "transform 0.9s cubic-bezier(0.2, 0.8, 0.2, 1)" };
}
